import React from "react";

type SkeletonProps = {
  className?: string;
};

const Skeleton: React.FC<SkeletonProps> = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-gray-200 ${className}`} aria-hidden="true" />
);

export default Skeleton;
